<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { mapMutations, mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get, orderBy } from 'lodash';
import { pageConfig } from '@/common/service/page-config';
import { plansof } from '@/utils/chain';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  name: 'WhiteboardAddon',
  mixins: [base, planCommon],
  for: () => {
    const shouldHide = isZoomMeetingAsAddonCard();
    if(shouldHide) return [];
    if (window?.$config('plan') === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP) {
      return false;
    }
    return planTypes.map([planTypes.ZOOM_ROOMS, planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS]);
  },
  data() {
    return {
      planType: planTypes.ZOOM_WHITEBOARD,
      title: '',
      description: this.$t('billing.zoom_whiteboard.desc'),
    };
  },
  created() {
    this.autoAdd();
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    setSubTitle() {
      const { amount } = this.lowestPlan;
      this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    },
    autoAdd() {
      const autokey = `__autoadded_${planTypes.ZOOM_WHITEBOARD}__`;
      if (window[autokey]) return;
      const { category, planType: standalonePlanType } = pageConfig?.editConfig ?? {};
      // HARDCODE autoadd only for buying standalone rooms;
      if (![planTypes.ZOOM_ROOMS].includes(standalonePlanType)) return;
      // while plan is also standalone
      const planType = getPlanTypeByCategory(this.$query.plan);
      if (![planTypes.ZOOM_WHITEBOARD, planTypes.ZOOM_WHITEBOARD_PLUS].includes(planType)) return;
      const plansOfType = plansof(this.planMapFlat).type(this.planType).get();
      const isNoneTargetCateory = !plansOfType.some((x) => x.category === category);
      if (isNoneTargetCateory) this.addOn();
      window[autokey] = true;
    },
    addOn(...args) {
      this.updateSelectPlan({
        plan_code: this.lowestPlan?.plan_code,
        cartInfo: {
          selected_number: 1,
        },
      });
      base.methods.addOn.call(this, ...args)
    },
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(
        this.planMapFlat.filter((p) => p.type === this.planType && p.category === this.category),
        ['amount'],
        'asc',
      );

      return get(list, [0], {});
    },
  },
  watch: {
    lowestPlan: {
      deep: true,
      immediate: true,
      handler() {
        this.setSubTitle()
      }
    }
  }
};
</script>
